import React from "react";
import { FaWifi, FaUtensils, FaConciergeBell, FaTv, FaWind, FaParking, FaSwimmingPool, FaSpa, FaDumbbell, FaLeaf, FaShuttleVan, FaCoffee } from "react-icons/fa";

// Maps hotel DB fields to meaningful amenity list
const buildAmenities = (hotel) => {
    const amenities = [];

    // Always present for any hotel in the system
    amenities.push({ icon: <FaWifi />, label: "Free Wi-Fi" });
    amenities.push({ icon: <FaWind />, label: "Air Conditioning" });
    amenities.push({ icon: <FaTv />, label: "TV in Room" });
    amenities.push({ icon: <FaParking />, label: "Parking" });

    // Food-type based
    if (hotel?.foodType === "Pure Veg") {
        amenities.push({ icon: <FaLeaf />, label: "Pure Veg Kitchen" });
    } else if (hotel?.foodType === "Non-Veg") {
        amenities.push({ icon: <FaUtensils />, label: "Multi-cuisine Restaurant" });
    } else {
        amenities.push({ icon: <FaUtensils />, label: "Restaurant" });
    }

    // Capacity / star-rating based
    const stars = hotel?.starRating || 0;
    if (stars >= 3) {
        amenities.push({ icon: <FaCoffee />, label: "Café / Lounge" });
        amenities.push({ icon: <FaConciergeBell />, label: "Room Service" });
    }
    if (stars >= 4) {
        amenities.push({ icon: <FaDumbbell />, label: "Fitness Centre" });
        amenities.push({ icon: <FaShuttleVan />, label: "Airport Transfer" });
    }
    if (stars >= 5) {
        amenities.push({ icon: <FaSwimmingPool />, label: "Swimming Pool" });
        amenities.push({ icon: <FaSpa />, label: "Spa & Wellness" });
    }

    return amenities;
};

const HotelDetailAmenities = ({ hotel, isMobile = false }) => {
    const amenities = buildAmenities(hotel);

    return (
        <div style={{ background: "#fff", borderRadius: "16px", padding: isMobile ? "14px" : "24px", boxShadow: "0 4px 15px rgba(0,0,0,0.04)", marginBottom: "25px", border: "1px solid #f5f5f5" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", gap: "10px" }}>
                <h3 style={{ fontSize: isMobile ? "1.1rem" : "1.3rem", fontWeight: "900", color: "#1a1a1a", margin: 0, letterSpacing: "-0.5px" }}>Popular Amenities</h3>
                <span style={{ color: "#EE2E24", fontWeight: "800", cursor: "pointer", fontSize: isMobile ? "0.74rem" : "0.85rem", textDecoration: "underline", whiteSpace: "nowrap" }}>VIEW ALL</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, minmax(0, 1fr))" : "repeat(3, 1fr)", gap: "10px" }}>
                {amenities.map((a, i) => (
                    <div key={i} style={{
                        display: "flex",
                        alignItems: "center",
                        gap: isMobile ? "6px" : "10px",
                        fontSize: isMobile ? "0.75rem" : "0.85rem",
                        color: "#444",
                        padding: isMobile ? "8px" : "10px",
                        borderRadius: "10px",
                        background: "#fafafa",
                        border: "1px solid #f0f0f0",
                        transition: "all 0.2s"
                    }}
                        onMouseEnter={e => {
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.borderColor = "#EE2E24";
                            e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={e => {
                            e.currentTarget.style.background = "#fafafa";
                            e.currentTarget.style.borderColor = "#f0f0f0";
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                    >
                        <span style={{ color: "#EE2E24", fontSize: "1rem" }}>{a.icon}</span>
                        <span style={{ fontWeight: "700" }}>{a.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HotelDetailAmenities;
